import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=9d1d5214&scoped=true"
import script from "./SplitButton.vue?vue&type=script&lang=js"
export * from "./SplitButton.vue?vue&type=script&lang=js"
import style0 from "./SplitButton.vue?vue&type=style&index=0&id=9d1d5214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1d5214",
  null
  
)

export default component.exports